import React from 'react';
import { useEffect, useState, useRef } from "react";
import styled from 'styled-components';
import NavButton from '../../homepage/header-banner/TopNavButton';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import { Grid } from '@mui/material';
//import './sidebar.css';
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute";
import CardWrap from '../../microservice/components/CardWrapper';
// import config from '../components/config';
import '../../container/Box/Components/Box-Style.css'
import Sidebar from '../../container/Sidebar/Sidebar';
import CloudConsultCp from '../../homepage/consult/cloudconsult-cp';
import '../../Style/typo.css'
import BanneServerApplication from '../../container/Banner/banner-serverApplication';
import DividerComponent from '../../container/Divider/divider';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import BannerPrivateCloudVN from '../../container/Banner/banner-privateCloud-vn';
import SidebarVN from '../../container/Sidebar/Sidebar-vn';
import HeaderVn from '../../detailpageVN/Page/component/headervn';
import FooterVn from '../../detailpageVN/Page/component/footervn';

const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;


// Titlecloudcompute
function SimpleUrlVN() {
    const isMobile = useIsMobile();
    useEffect(() => {
        document.title = 'Simple-Url-Shortener - Serverless Application - Private Cloud';
    }, []);
    return (
        <Sysfont className='App'>
            <HeaderVn />
            <BannerPrivateCloudVN />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarVN />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("Simple-Url-Shortener")} */}
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class="typo-21 typo-medium typo-black">Simple URL Shortener là gì?</p></BoxTitle>

                            <BoxText  >
                                <p class="typo-14">Simple URL Shortener giúp rút gọn các địa chỉ URL dài, chứa nhiều ký tự khó nhớ thành các URL ngắn gọn, dễ sử dụng hơn. Các URL rút gọn này thường dùng kèm với PURLs.</p>
                                <p class="typo-14">(Ví dụ) <u>abc.vora.net/desk/marketing/survey.html?id=a3bc65cd</u> </p>
                                <p class="typo-14">- Khi sử dụng tên miền chính =&gt; sus.so/aB2b3Aza </p>
                                <p class="typo-14">- Khi sử dụng tên miền công ty =&gt; 자사도메인/aB2b3Aza </p>
                                <br></br>
                                <p class="typo-14">Cung cấp URL ngắn gọn, dễ đọc: sử dụng website thông thường (có thể nhận diện URL của website trước đó). </p>
                                <p class="typo-14">- Khi sử dụng tên miền chính =&gt; sus.so/ tên thương hiệu/tuỳ chọn(các từ như help, sales, marketing) </p>
                                <p class="typo-14">- Khi sử dụng tên miền công ty =&gt; domain công ty/tuỳ chọn(các từ như help, sales, marketing) </p>
                            </BoxText>
                        </BoxContent>
                        <DividerComponent />
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class="typo-21 typo-medium typo-black">PURLs (Personalized URLs)</p></BoxTitle>
                            <BoxText  >
                                <p class="typo-14">- PURLs là các URL được cá nhân hóa cho từng người dùng, thường dùng trong chiến dịch marketing để tăng tính tương tác và hiệu quả. </p>
                                <p class="typo-14">- Mỗi PURL là một liên kết trang web duy nhất, cá nhân hoá. Hiển thị nội dung được cá nhân hóa theo người dùng. </p>
                                <p class="typo-14">- Giúp marketer theo dõi hành vi như lượt truy cập, phản hồi, khảo sát, hoặc quà tặng một cách chính xác.</p>
                            </BoxText>
                        </BoxContent>
                        <DividerComponent />
                        {/* {CardWrap("<p class='typo-21 typo-medium typo-black'>Email / SMS 마케팅시 단축 URL 사용 예</p>", "", "", "https://hanbiro.com/cloud/library2/simple-url-shortener/simple-url-shortener-1.svg")} */}
                        <BoxContent>
                            <BoxText ><p class="typo-21-sm typo-medium typo-black">Ví dụ về sử dụng URL rút ngắn trong marketing Email / SMS</p></BoxText>
                            <ImageWrap src="https://hanbiro.com/assets/images/cloud/en/simple-url-shortener-1.png"></ImageWrap>
                        </BoxContent>
                        {/*CardWrap("• 가격",config.tb8_header,config.tb8_content)*/}

                        {/* <CloudConsultCp /> */}
                    </Col>
                </Row>
            </Container>

            <FooterVn />
        </Sysfont>
    );
};

const BoxTitle = styled.div`
  text-align: left;
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 20px;
`

const BoxSubText = styled.div`
  margin-left: 7%;
`

const BoxContent = styled.div`
    ${'' /* box-shadow: 0 0.375rem 1.5rem 0 rgb(140 152 164 / 13%);
    border: 1px solid #E7EAF3;
    border-radius: 4px;
    margin-top: 20px;
    margin-bottom: 20px; */}
    text-align: left;
`

const BoxText = styled.div`
    margin: 5px;
    line-height: 2em;
`

const ImageWrap = styled.img`
  width: 100%;
  object-fit: fill;
`
export default SimpleUrlVN;